import { render, staticRenderFns } from "./VideoInfoMarker.vue?vue&type=template&id=53a22a40"
import script from "./VideoInfoMarker.vue?vue&type=script&lang=js"
export * from "./VideoInfoMarker.vue?vue&type=script&lang=js"
import style0 from "./VideoInfoMarker.vue?vue&type=style&index=0&id=53a22a40&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports